<template>
  <q-page class="q-px-xl q-pb-lg bg-grey-1">
    <c-toast
      ref="toast"
      class="toast"
    />
    <div class="wrapper">
      <div class="pt-6 w-full">
        <h1 class="c-text-h2 c-text-gray-400 mb-16">
          Ações em massa
        </h1>
      </div>
    </div>
    <div>
      <p class="c-text-b1 ui-mb-2">
        Ocultar questões do SQ
      </p>
      <csv-batch-action
        :submit-function="handleUnlistQuestionsSubmit"
        :base-entity="['Id da questao', 'Oculto (true/false)']"
      />
    </div>
    <div class="ui-mt-4">
      <p class="c-text-b1 ui-mb-2">
        Associar solução em vídeo
      </p>
      <csv-batch-action
        :submit-function="handleHasVideoSolution"
        :base-entity="['Id da questao', 'Solucao em video (true/false)']"
      />
    </div>
    <div class="ui-mt-4">
      <p class="c-text-b1 ui-mb-2">
        Atualizar status (label) de questões
      </p>
      <csv-batch-action
        :submit-function="updateQuestionLabelsBatch"
        :base-entity="['Id da questão', 'Status da questão (desatualizada/gabarito extraoficial/anulada/gabarito preliminar/gabarito definitivo)']"
      />
    </div>
  </q-page>
</template>

<script>
import CsvBatchAction from '@/components/CsvBatchAction';

export default {
  name: 'BatchActions',
  components: {
    CsvBatchAction,
  },
  methods: {
    async handleUnlistQuestionsSubmit(lines) {
      await this.$services.questionsrest.updateUnlistBatch(lines);
    },
    async handleHasVideoSolution(lines) {
      await this.$services.questionsrest.updateHasVideoSolutionBatch(lines);
    },
    async updateQuestionLabelsBatch(lines) {
      await this.$services.questionsrest.updateQuestionLabelsBatch(lines);
    },
  },
};
</script>
